import { Currency, Timestamp } from '@marmon/shared/types/common';

export const TIME_PERIOD_MAX = 2;

export type TimePeriodOverhead = {
	/**
	 * The overhead cost in cents based on transaction count. This gives the app the ability
	 * to determine the overhead cost when segmenting.
	 */
	overheadCostInCentsPerTransaction: number;

	/**
	 * The total amount of transactions associated with this time period
	 */
	transactionCount: number;

	/**
	 * the total overhead in cents for this time period
	 */
	overheadCostInCents: number;
};

export const DefaultTimePeriodOverhead = (): TimePeriodOverhead => ({
	transactionCount: 0,
	overheadCostInCents: 0,
	overheadCostInCentsPerTransaction: 0,
});

export interface TimePeriod<D = Timestamp> extends TimePeriodOverhead {
	minDate: D;
	maxDate: D;

	/**
	 * Mirrors the parent analysis currency so period inputs use the same symbol.
	 */
	currency: Currency;
}
